module.exports = __webpack_public_path__ + "static/media/cz.047e732d.svg";